import ImgWithFallbackMainBanner from './ImgWithFallbackMainBanner';
export default ImgWithFallbackMainBanner;
